// Полоса вкладок карточки.
//
// ПОЧЕМУ ВКЛАДКИ, А НЕ ОДНА ДЛИННАЯ СТРАНИЦА. У сделки полей под сорок, к ним журнал,
// файлы, связи и лента. Одной простынёй это листают до конца ровно один раз. Вкладки
// разрезают карточку по вопросам: «что в ней написано», «с чем она связана», «что к ней
// приложено», «кто её менял», «что вокруг неё происходило».
//
// СЧЁТЧИКИ НА ВКЛАДКАХ обязательны: без них человек не знает, есть ли смысл нажимать.
// Ноль печатается нулём, а не прячется: «Документы 0» — это ответ «вложений нет»,
// пустая вкладка без счётчика читается как «не догрузилось».

import { ВКЛАДКИ } from './types'
import type { КодВкладки } from './types'

interface Props {
  текущая: КодВкладки
  onВыбор: (в: КодВкладки) => void
  /** Счётчики: код вкладки → число записей. Отсутствие ключа значит «считать нечего». */
  счётчики?: Partial<Record<КодВкладки, number>>
}

export function CardTabs({ текущая, onВыбор, счётчики }: Props) {
  return (
    <div className="card-tabs" role="tablist">
      {ВКЛАДКИ.map((в) => {
        const n = счётчики?.[в.код]
        return (
          <button
            key={в.код}
            type="button"
            role="tab"
            id={`tab-${в.код}`}
            aria-selected={в.код === текущая}
            aria-controls={`panel-${в.код}`}
            className={`card-tab${в.код === текущая ? ' active' : ''}`}
            onClick={() => onВыбор(в.код)}
          >
            {в.подпись}
            {n !== undefined && <span className="faint card-tab-n"> {n}</span>}
          </button>
        )
      })}
    </div>
  )
}
